<template>
  <div class="project_history">
    <div class="table_wrapper">
      <table class="ptable">
        <thead class="ptable__thead">
        <tr>
          <th class="vertical_align">#</th>
          <th class="vertical_align">
            {{ $t("project.label_project_name") }}
          </th>
          <th class="vertical_align">
            {{ $t("project.employee_type") }}
          </th>
          <th class="vertical_align">
            {{ $t("label.start_date") }}
          </th>
          <th class="vertical_align">
            {{ $t("label.end_date") }}
          </th>
        </tr>
        </thead>
        <tbody class="ptable__tbody">
        <tr v-for="(item, key) in itemsRender" :key="key">
          <td>{{ tableIndex(key) }}</td>
          <td>{{ item.name_project }}</td>
          <td>
            <div>
              {{ item.position }}
            </div>
          </td>
          <td>{{ item.start_date }}</td>
          <td>{{ item.end_date }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="itemsRender.length === 0" class="text-center ">
      Không có trong dự án nào
    </div>
    <a-pagination v-if="totalItems > 0" v-model:current="current" :total="totalItems" :pageSize="pageSize" />
  </div>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import moment from "moment";

export default {
  computed: {
    ...mapGetters({
      projectsHistory: "projectManagement/projectsHistory",
    }),
    totalItems() {
      return this.projectsHistory.length;
    },
    itemsRender() {
      let start = (this.current - 1) * this.pageSize;
      let end = this.current * this.pageSize;
      return this.projectsHistory.slice(start, end);
    },
    
  },
  data() {
    return {
      contract_management: [
        {
          effective_date: "a",
          document_quote_name: "asd",
        },
      ],
      current: 1,
      pageSize: 5,
    };
  },
  async created() {
    this.setLoading(true);
    await this.getProjectsHistory({id: this.$route.params.id});
    this.setLoading(false);
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    ...mapActions("projectManagement", ["getProjectsHistory"]),
    tableIndex(key) {
      return (this.current - 1) * this.pageSize + key + 1;
    }
  },
};
</script>
<style lang="scss" scoped>
.project_history {
  background: #ffffff;
  padding-top: 36px;
  padding-bottom: 20px;

  .table_wrapper {
    max-height: 320px;
    overflow: hidden;
    margin-bottom: 25px;

    .ptable {
      width: 100%;
      border-collapse: separate;
      border-spacing: 0 8px;

      &__thead {
        padding: 1em;
        background: #d3edff;

        th {
          text-align: left;
          font-style: normal;
          font-weight: 700;
          font-size: 14px;
          line-height: 17px;
          color: #303c54;
          border-bottom: 0 !important;
          height: 44px;
          padding-left: 20px;

          &:nth-child(1) {
            width: 7%;
            border-radius: 10px 0 0 10px;
            border: 1px solid transparent;
          }

          &:nth-child(2) {
            width: 25%;
          }

          &:nth-child(4) {
            width: 22%;
          }

          &:nth-child(5) {
            width: 22%;
            border-radius: 0 10px 10px 0;
            border: 1px solid transparent;
          }
        }
      }

      &__tbody {
        padding: 1em;

        td {
          text-align: left;
          font-weight: 400;
          font-size: 14px;
          line-height: 17px;
          color: #303c54;
          vertical-align: middle;
          height: 44px;
          border: 1px solid #d3edff;
          border-left: 0;
          border-right: 0;
          padding-left: 20px;

          &:first-child {
            border-left: 1px solid #d3edff;
            border-radius: 10px 0 0 10px;
          }

          &:last-child {
            border-right: 1px solid #d3edff;
            border-radius: 0 10px 10px 0;
          }
        }
      }
    }
  }
}

/deep/ .ant-pagination {
  display: flex;
  justify-content: center;
}

/deep/ .ant-pagination-item {
  width: 30px;
  height: 30px;
  text-align: center;
  display: inline-block;
  margin: 0 2px;
  padding: 0;
  position: relative;
  border-radius: 10px;
  background: #ffffff;
  color: #8d8282;
  border: none;
  font-size: 13px;

  &:hover {
    background: #2183dd;

    a {
      color: #ffffff;
    }
  }
}

/deep/ .ant-pagination-item-active {
  font-weight: 500;
  background: #2183dd;
  color: #ffffff !important;

  a {
    color: #ffffff !important;
  }
}

/deep/ .ant-pagination-item-link {
  border: none;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}


/deep/ .ant-pagination-prev {
  margin-right: 0;

  a {
    color: #2183dd;
  }
}

/deep/ .ant-pagination-next {
  a {
    color: #2183dd;
  }
}

/deep/ .ant-pagination-disabled {
  a {
    color: #8d8282;
  }
}
/deep/ .ant-pagination-jump-prev-custom-icon, /deep/.ant-pagination-jump-next-custom-icon {
  pointer-events: none;
}
</style>